import ajax from "@/common/ajax.js";
import { skk_axios as axios } from "../common/ajax";

//获取更新历史
export function updateHistory() {
  return ajax.request.get("/api/update/updateHistory");
}

/**
 * 更新详情
 * @param {*} params
 * @returns
 */
export const updateDetail = (params) => {
  return axios({
    url: "/api/update/updateDetail",
    method: "get",
    params,
  });
};

// 提交更新
export function updateSubmit(data) {
  return ajax.request.post("/api/update/handler", data);
}

//其中驳回编辑后的 提交更新 用这个接口
export function updateSubmitEdit(data) {
  return ajax.request.post("/api/update/edit", data);
}

//点击左侧菜单信息更新时，判断用户满足条件可以更新吗
export function getUpdateRecordID() {
  return ajax.request.get("/api/update/getUpdateRecordID");
}

/**
 * 获取更新信息展示
 * @param {*} params
 * @returns
 */
export const getUpdateData = (params) => {
  return axios({
    url: "/api/update/getData",
    method: "get",
    params,
  });
};

/**
 * 获取驳回的信息
 * @param {*} params
 * @returns
 */
export const updateNo = (params) => {
  return axios({
    url: "/api/update/no",
    method: "get",
    params,
  });
};
